import React, { useEffect } from "react"
import { Link, graphql } from "gatsby"
import { Helmet } from 'react-helmet'

import SEO from "../components/seo"
import Page from "../components/page"
import PageTitle from "../components/page-title"
import Container from "../components/container"

export default function PageTemplate({data, pageContext}) {
  const node = data.contentfulPage

  return (
    <Page>
      <Helmet bodyAttributes={{ class: 'page-basic' }} />
  
      <SEO title={node.title} />
  
      <PageTitle title={node.title} subtitle={node.subTitle} />
  
      <Container>
        <div className="default-content body" dangerouslySetInnerHTML={{ __html: node.content.childMarkdownRemark.html, }} />
      </Container>
  
    </Page>
  )
}

export const pageQuery = graphql`
query PageTemplate($slug: String!) {
  contentfulPage(slug: {eq: $slug}) {
    slug
    subTitle
    title
    linkTitle
    content {
      childMarkdownRemark {
        html
      }
    }
  }
}
`